export default {
  title: 'Factuur aanvragen',
  form: {
    is_receipt_required: {
      label: 'Factuur aanvragen per e-mail',
    },
    company_name: {
      placeholder: 'Bedrijfsnaam (optioneel)',
    },
    first_name: {
      placeholder: 'Voornaam',
    },
    last_name: {
      placeholder: 'Achternaam',
    },
    address: {
      placeholder: 'Straat + huisnummer',
    },
    zip_code: {
      placeholder: 'Postcode',
    },
    city: {
      placeholder: 'Stad',
    },
    tax_id: {
      placeholder: 'BTW-nummer',
    },
    email: {
      placeholder: 'E-mailadres',
    },
  },
};
